const timeZone = 'Europe/Kiev'

export function dateFilter (value) {
    if (value) {
        return new Date(value).toLocaleDateString('ru', {timeZone})
    }
}

export function timeFilter (value) {
    if (value) {
        return new Date(value).toLocaleTimeString('ru', {timeZone})
    }
}
